import { CommonModule } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

import { TiimeButtonToggleModule, TiimeFormModule } from 'tiime-material';

import { MissionAcceptanceFormRowComponent } from '@common-shared/components/forms/mission-acceptance-form-row/mission-acceptance-form-row.component';
import { Level } from '@enums/level.enum';
import { MissionAcceptanceAcceptationForm } from '@forms/mission-acceptance-form/mission-acceptance-acceptation-form';
import { CodeAndLabel } from '@models/code-and-label';

@Component({
  selector: 'app-acceptation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TiimeButtonToggleModule,
    TiimeFormModule,
    MissionAcceptanceFormRowComponent
  ],
  templateUrl: './acceptation-form.component.html',
  styleUrl: './acceptation-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class AcceptationFormComponent {
  readonly riskLevels: InputSignal<CodeAndLabel<Level>[]> = input.required<CodeAndLabel<Level>[]>();

  form: MissionAcceptanceAcceptationForm;

  constructor(private readonly formGroupDirective: FormGroupDirective) {}

  ngOnInit(): void {
    this.form = this.formGroupDirective.control.get('acceptation') as MissionAcceptanceAcceptationForm;
  }
}
